import 'slick-carousel';

export default function () {

	$('.bg-scroll').slick({
		dots:false,
		fade:true,
		arrows:false,
		autoplay: true,
		autoplaySpeed: 3000
	});

	$(document).on('click', '.bg-scroll__left', function(e){

		e.preventDefault();

		$('.bg-scroll').slick('slickPrev');

	});


	$(document).on('click', '.bg-scroll__right', function(e){

		e.preventDefault();

		$('.bg-scroll').slick('slickNext');

	});

}


// WEBPACK FOOTER //
// ./scripts/components/SetupHomeBackgroundScroll.js